import React, { useContext, useRef } from "react";
import "./../../components/style/global.css";
import { useEffect, useState } from "react";
import ProjectForm from "../ProjectForm";
import PaletteMaker from "../PaletteMaker";
import { stripePublicKey } from "../../config";
import DialogBoxWithConfirmation from "../util/DialogBoxWithConfirmation";
import ProjectsList from "./ProjectsList";
import { markerTypes } from "../map/MapWithMarker";
import { ICON_INDEX_DELETED } from "../map/GPX/Resources";
import UsersList from "./admin/UsersList";
import UserProfile from "../user/UserProfile";
import { LoadingBox } from "../util/LoadingBox";
import { closeLoadingBox } from "../util/LoadingBox";
import BillingAddress from "../user//billingAddress/BillingAddress";
import Contact from "../user/Contact";
import Invoices from "../user/Invoices/Invoices";
import Menu from "./Menu";
import Subscription from "../user/Subscription";
import CreditCards from "../payment/CreditCards";
import PaymentPage from "../payment/PaymentPage";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../ThemeContext";
import { roadmakerApi } from "../../api/roadmakerApi";
const PUBLIC_KEY = stripePublicKey;
const stripeTestPromise = PUBLIC_KEY ? loadStripe(PUBLIC_KEY) : null;

const Home = ({ userData, setUserData, logout }) => {
  const [iconIndexArray, setIconIndexArray] = useState(userData.iconIndexArray);
  const [projects, setProjects] = useState([]);
  const [createProject, setCreateProject] = useState(
    "btn btn-outline-primary mt-4"
  );
  const [deleteProjects, setDeleteProjects] = useState(
    "btn btn-outline-danger mt-4 ms-4"
  );
  const [selectedProject, setSelectedProject] = useState(null);
  const [isProjectsEmpty, setIsProjectsEmpty] = useState(false);
  const [isAdmin, setIsAdmin] = useState();
  const [editingProject, setEditingProject] = useState(null);
  const [projectsName, setProjectsName] = useState(null);
  const [modifiedName, setModifiedName] = useState("");
  const [modifiedTag, setModifiedTag] = useState("");
  const [afficheMessageErreur, setAfficheMessageErreur] = useState(false); //pour le meme nom
  const [afficheMessageErreurVide, setAfficheMessageErreurVide] =
    useState(false); //pour un nom vide
  const [afficheMessageErreurType, setAfficheMessageErreurType] =
    useState(false);
  const [userName, setUserName] = useState(userData.name);
  const [avatar, setAvatar] = useState(userData.avatar);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [userPack, setUserPack] = useState(userData.pack);
  const [pack, setPack] = useState(userData.pack);
  const [visibleComponent, setVisibleComponent] = useState("Hub");
  const [invoiceBA, setInvoiceBA] = useState({});
  const [billingAddresses, setBillingAddresses] = useState([]);

  const savedCart = sessionStorage.getItem("cart");
  const initialCart = savedCart ? JSON.parse(savedCart) : [];
  const [cart, setCart] = useState(initialCart);
  const { t } = useTranslation();

  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    sessionStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    /**
     * Récupère les projets de l'utilisateur
     */
    async function fetchData() {
      try {
        LoadingBox({
          text: t("loadingCourses"),
          icon: "info",
        });
        const userProjects = await roadmakerApi.projects.listByUser(
          userData._id
        );
        setProjects(userProjects);
      } catch (error) {
        console.log(error);
      } finally {
        closeLoadingBox();
      }
    }
    setIsAdmin(userData.admin);
    fetchData();
  }, [userData._id]);

  useEffect(() => {
    /**
     * Récupère les noms des projets de l'utilisateur,
     * se met à jour à chaque fois que la liste des projets est modifiée
     * @param {array} projects
     *
     */
    const userProjects = projects.filter((project) => {
      return project.user === userData._id;
    });
    // Extraire les noms des projets de l'utilisateur
    const projectsNames = userProjects.map((project) => project.name);
    setProjectsName(projectsNames);
    if (userProjects.length === 0) {
      setIsProjectsEmpty(true);
    } else {
      setIsProjectsEmpty(false);
    }
  }, [projects]);

  /**
   * Supprime l'icone du marker du iconIndexArray
   * @param {object} marker
   */
  const deleteFromIconIndexArray = (marker) => {
    if (marker.type === markerTypes.touristic) {
      // On contineu uniquement si le marker contient une icone
      if (marker.iconName && marker.iconName.length > 0) {
        // On vérifie que l'icone n'existe pas déjà dans la liste du User
        if (iconIndexArray.includes(marker.iconName)) {
          const iconNameIndex = iconIndexArray.indexOf(marker.iconName);
          if (iconNameIndex !== -1) {
            iconIndexArray[iconNameIndex] =
              ICON_INDEX_DELETED + marker.iconName;
          }
        }
      }
    }
  };

  /**
   * Supprime les markers associés au projet
   * @param {string} projectId
   * @async
   * @method
   * @throws {error} error
   */

  const deleteProjectMarkers = async (projectId) => {
    const projectMarkers = await roadmakerApi.pois.listByProject(projectId);
    projectMarkers.forEach((marker) => {
      // Par sécurité, on ne supprime pas la valeur par défaut
      if (iconIndexArray.length > 1) deleteFromIconIndexArray(marker);
    });
    await roadmakerApi.pois.removeByProject(projectId);
    await roadmakerApi.users.update(userData._id, {
      iconIndexArray: iconIndexArray,
    });
  };

  /**
   * Permet de lancer la suppression d'un projet
   * @param {string} id
   * @param {boolean} showConfirm
   */

  const handleDeleteProject = (id, showConfirm) => async (e) => {
    if (e) {
      e.stopPropagation();
    }
    if (showConfirm) {
      const confirmDelete = await DialogBoxWithConfirmation({
        title: t("titleDialogBoxSupprCourses"),
        text: t("messageDialogBoxSupprCourse"),
        icon: "warning",
        cancelButtonText: t("no"),
        confirmButtonText: t("yes"),
      });

      /// Confirmer la suppression
      if (confirmDelete) {
        await deleteProject(id);
      }
    } else {
      await deleteProject(id);
    }
  };

  /**
   * Permet de lancer la suppression de plusieurs projets
   * @async
   * @method
   * @throws {error} error
   *
   *
   */
  const handleDeleteSelectedProjects = async () => {
    if (selectedProjects.length === 0) {
      return;
    }

    const confirmDelete = await DialogBoxWithConfirmation({
      title: t("titleDialogBoxSupprMultipleCourses"),
      text: t("messageDialogBoxSupprMultipleCourses"),
      icon: "warning",
      cancelButtonText: t("no"),
      confirmButtonText: t("yes"),
    });

    if (!confirmDelete) {
      return;
    }

    try {
      const deletionPromises = selectedProjects.map((projectId) =>
        handleDeleteProject(projectId, false)()
      );

      await Promise.all(deletionPromises);

      const updatedProjects = projects.filter(
        (project) =>
          !selectedProjects.includes(project._id) &&
          project.user === userData._id
      );

      setProjects(updatedProjects);
      setSelectedProjects([]);
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Permet de supprimer un projet
   * @param {string} id
   * @async
   * @method
   * @throws {error} error
   */
  const deleteProject = async (id) => {
    try {
      LoadingBox({
        text: t("deleteCourse"),
        icon: "info",
      });

      const project = await roadmakerApi.projects.get(id);

      if (!project) {
        console.log("Le projet n'existe pas.");
        return;
      }

      const projectName = project.name;
      setProjectsName((prevNames) =>
        prevNames.filter((name) => name !== projectName)
      );

      // Les routes POI vérifient encore la propriété via le projet parent :
      // elles doivent donc être appelées avant la suppression du projet.
      await deleteProjectMarkers(id);
      await roadmakerApi.projects.remove(id);
      const newProjects = projects.filter(
        (project) => project._id !== id && project.user === userData._id
      );
      setProjects(newProjects);

      closeLoadingBox();
    } catch (error) {
      console.error(
        "Une erreur est survenue lors de la suppression du projet:",
        error
      );
      closeLoadingBox();
    }
  };

  /**
   * Affiche le projet sélectionné
   * @param {object} project
   */
  const handleProjectClick = (project) => {
    setSelectedProject(project._id);
    setModifiedName(project.name);
    setModifiedTag(project.tag);
    setVisibleComponent("PaletteMaker");
    setSelectedProjects([]);
  };

  /**
   * Vérifie si le nom du projet existe déjà
   * @param {event} e
   */
  const checkName = (e) => {
    setAfficheMessageErreur(true);
    setTimeout(() => {
      setAfficheMessageErreur(false);
    }, 5000);
  };

  /**
   * Vérifie si le nom du projet est vide
   * @param {event} e
   */
  const checkEmptyName = (e) => {
    setAfficheMessageErreurVide(true);
    setTimeout(() => {
      setAfficheMessageErreurVide(false);
    }, 5000);
  };

  /**
   * Vérifie si le type du projet est vide
   *  @param {event} e
   */
  const checkEmptyType = (e) => {
    setAfficheMessageErreurType(true);
    setTimeout(() => {
      setAfficheMessageErreurType(false);
    }, 5000);
  };

  /**
   * Met à jour le nom du projet
   * @param {event} e
   * @async
   * @method
   */
  const saveModified = async (e) => {
    e.preventDefault();
    //vérifier si le nom qu'on veut choisir n'existe pas déjà dans les noms des projets existants
    if (modifiedName !== editingProject.name) {
      if (projectsName.includes(modifiedName)) {
        checkName();
        console.log(projectsName);
        return;
      }
      if (modifiedName === "") {
        checkEmptyName();
        return;
      }
    }
    console.log("jest: Modification réussite");
    // mettre à jour le nom du projet
    await roadmakerApi.projects.update(editingProject._id, {
      name: modifiedName,
      tag: modifiedTag,
    });
    const updatedProjects = projects.map((p) => {
      if (p._id === editingProject._id) {
        return { ...p, name: modifiedName, tag: modifiedTag };
      }
      return p;
    });
    setProjects(updatedProjects);
    setModifiedName("");
    setModifiedTag("");
    setEditingProject(null);
  };

  /**
   * Déconnecte l'utilisateur : détruit la session serveur (POST /auth/logout)
   * et efface le cookie. Aucun document n'est stocké localement.
   */
  const disconnectUser = () => {
    if (logout) {
      logout();
    } else {
      // Repli si le logout serveur n'est pas disponible : la session expire
      // côté serveur et GET /auth/me renverra 401.
      sessionStorage.removeItem("cart");
    }
    window.location.reload();
  };

  // Renseigné par l'éditeur ouvert : rend vrai si des modifications ne sont
  // pas sauvegardées.
  const unsavedChangesRef = useRef(null);

  /**
   * Avant de quitter l'éditeur par le menu, demande confirmation si le
   * projet a des modifications non sauvegardées. Rend vrai si on peut partir.
   */
  const confirmLeaveEditor = async () => {
    // L'éditeur (ouvert depuis la liste ou à la création) remet la
    // référence à null en se fermant.
    if (!unsavedChangesRef.current?.()) {
      return true;
    }
    const leave = await DialogBoxWithConfirmation({
      title: t("unsavedChangesTitle"),
      text: t("unsavedChangesText"),
      icon: "warning",
      confirmButtonText: t("leaveWithoutSaving"),
      cancelButtonText: t("stayOnProject"),
    });
    // Départ confirmé : l'avertissement du navigateur (déconnexion = rechargement
    // de la page) ne doit pas redemander.
    if (leave) unsavedChangesRef.current = null;
    return leave;
  };
  const guardedBackToHub = async () => {
    if (await confirmLeaveEditor()) backToHub();
  };
  const guardedSetVisibleComponent = async (component) => {
    if (component === visibleComponent || (await confirmLeaveEditor())) {
      setVisibleComponent(component);
    }
  };
  const guardedDisconnectUser = async () => {
    if (await confirmLeaveEditor()) disconnectUser();
  };

  /**
   * Retourne à la liste des projets
   */
  const backToHub = () => {
    setSelectedProject(null);
    setSelectedProjects([]);
    setVisibleComponent("Hub");
    setCreateProject("btn btn-outline-primary mt-4");

    /**
     * Récupère les projets à jour de l'utilisateur
     * @async
     */
    async function MajProjects() {
      const userProjects = await roadmakerApi.projects.listByUser(
        userData._id
      );
      setProjects(userProjects);
    }
    MajProjects();
  };

  /**
   * Dupliquer un projet existant
   * @param {object} project -Projet original a dupliquer
   */

  const duplicateProject = async (project) => {
    const confirmDelete = await DialogBoxWithConfirmation({
      title: t("duplicateProject"),
      text: t("messageDuplicationProject"),
      confirmButtonText: t("yes"),
      cancelButtonText: t("no"),
      icon: "warning",
    });
    if (confirmDelete) {
      LoadingBox({
        text: "Duplication du projet en cours ...",
        icon: "info",
      });
      try {
        // Le serveur refuse un nom de plus de 200 caractères : le nom source
        // est tronqué pour que le suffixe tienne.
        const withSuffix = (suffix) =>
          `${project.name.slice(0, 200 - suffix.length)}${suffix}`;
        let newProjectName = withSuffix("_copie");
        let copyNumber = 1;

        // Vérifier si le nom généré est déjà inclus dans projectNames
        while (projectsName.includes(newProjectName)) {
          newProjectName = withSuffix(`_copie_${copyNumber}`);
          copyNumber++;
        }

        // Duplication complète (POI + médias) faite côté serveur, en une
        // seule requête tout-ou-rien.
        const duplicatedProject = await roadmakerApi.projects.duplicate(
          project._id,
          newProjectName
        );

        setProjects((currentProjects) => [...currentProjects, duplicatedProject]);
        setProjectsName((currentNames) => [...(currentNames || []), newProjectName]);
        closeLoadingBox();
      } catch (error) {
        console.error("Erreur lors de la duplication du projet :", error);
        closeLoadingBox();
        await DialogBoxWithConfirmation({
          title: t("duplicationProjectErrorTitle"),
          text: t("duplicationProjectError"),
          icon: "error",
          showCancelButton: false,
        });
      }
    }
  };

  const addToCart = (product) => {
    setCart((currentCart) => [...currentCart, product]);
  };

  return (
    <div className={`${theme} min-vh-100`}>
      <div className="hub-header d-flex flex-row align-items-center justify-content-between p-1 shadow-sm container-fluid">
        <div className="d-flex align-items-center">
          <img
            src="/rm_imgs/logo_header.png"
            alt="logo"
            className="logo-header  me-2"
          />
          <label className="fs-3 fw-bold col-2 me-4 d-none d-sm-block text-white">
            RoadMaker
          </label>
        </div>

        <label className="fs-6 fw-bold col-3 me-4 d-block d-sm-none tewt-white">
          RoadMaker
        </label>

        <label className="titleHeader fs-2 fw-bold col-3 d-none d-sm-block   me-5   text-white">
          {t("welcome")} {userName ? userName : userData.name}
        </label>

        <label className="fs-6 fw-bold col-3 d-block d-sm-none   me-4 text-white">
          {t("welcome")} {userName ? userName : userData.name}
        </label>

        <div>
          <Menu
            setVisibleComponent={guardedSetVisibleComponent}
            isAdmin={isAdmin}
            disconnectUser={guardedDisconnectUser}
            backToHub={guardedBackToHub}
            setAvatar={setAvatar}
            avatar={avatar}
            cart={cart}
            setCart={setCart}
            userData={userData}
            billingAddresses={billingAddresses}
          />
        </div>
      </div>

      <div>
        {visibleComponent !== "Form" ? (
          <div className="container">
            {visibleComponent === "Hub" && (
              <>
                <h2
                  className={
                    theme === "bg-white"
                      ? "text-dark fw-bold mt-2"
                      : "text-white mt-2 fw-bold"
                  }
                >
                  {t("yourCourses")}
                </h2>
                <ProjectsList
                  projects={projects}
                  handleProjectClick={handleProjectClick}
                  handleDeleteProject={handleDeleteProject}
                  setEditingProject={setEditingProject}
                  userData={userData}
                  setProjects={setProjects}
                  editingProject={editingProject}
                  setModifiedName={setModifiedName}
                  setModifiedTag={setModifiedTag}
                  saveModified={saveModified}
                  afficheMessageErreur={afficheMessageErreur}
                  afficheMessageErreurVide={afficheMessageErreurVide}
                  modifiedName={modifiedName}
                  modifiedTag={modifiedTag}
                  selectedProjects={selectedProjects}
                  setSelectedProjects={setSelectedProjects}
                  duplicateProject={duplicateProject}
                  createProject={createProject}
                  handleShowForm={() => setVisibleComponent("Form")}
                  deleteProjects={deleteProjects}
                  handleDeleteSelectedProjects={handleDeleteSelectedProjects}
                  theme={theme}
                />
              </>
            )}
          </div>
        ) : (
          <ProjectForm
            userData={userData}
            setVisibleComponent={guardedSetVisibleComponent}
            unsavedChangesRef={unsavedChangesRef}
            afficheMessageErreur={afficheMessageErreur}
            afficheMessageErreurType={afficheMessageErreurType}
            afficheMessageErreurVide={afficheMessageErreurVide}
            checkName={checkName}
            checkEmptyName={checkEmptyName}
            checkEmptyType={checkEmptyType}
          />
        )}
      </div>

      {visibleComponent === "Users" && (
        <UsersList
          handleDeleteProject={handleDeleteProject}
          deleteProjectMarkers={deleteProjectMarkers}
        />
      )}

      {visibleComponent === "MyProfile" && (
        <UserProfile
          userData={userData}
          userName={userName}
          setUserName={setUserName}
          setUserData={setUserData}
          avatar={avatar}
          setAvatar={setAvatar}
        />
      )}

      {visibleComponent === "PaletteMaker" &&
        selectedProject &&
        selectedProjects.length === 0 && (
          <PaletteMaker
            projectId={selectedProject}
            userData={userData}
            userPack={userPack}
            setVisibleComponent={guardedSetVisibleComponent}
            unsavedChangesRef={unsavedChangesRef}
          />
        )}

      {visibleComponent === "BillingAdress" && (
        <BillingAddress
          userData={userData}
          setInvoiceBA={setInvoiceBA}
          invoiceBA={invoiceBA}
          billingAddresses={billingAddresses}
          setBillingAddresses={setBillingAddresses}
        />
      )}

      {visibleComponent === "Contact" && <Contact userData={userData} />}

      {visibleComponent === "Subscriptions" && (
        <Subscription
          userData={userData}
          setUserPack={setUserPack}
          setCart={setCart}
          addToCart={addToCart}
          cart={cart}
        />
      )}

      {visibleComponent === "CreditCard" && (
        <Elements stripe={stripeTestPromise}>
          <CreditCards userData={userData} />
        </Elements>
      )}

      {visibleComponent === "Invoices" && (
        <Invoices userData={userData} invoiceBA={invoiceBA} />
      )}

      {visibleComponent === "PaymentForm" && (
        <PaymentPage
          setUserPack={setUserPack}
          userData={userData}
          setCart={setCart}
          setPack={setPack}
          cart={cart}
        />
      )}
    </div>
  );
};

export default Home;
